
// import { swiper, swiperSlide } from 'vue-awesome-swiper';
// import 'swiper/css/swiper.css';

export default {
  components: {
    // swiper,
    // swiperSlide
  },
  props: {
    list: {
      type: Array,
      default: []
    },
  },
  data () {
    return {
      // 轮播项数据，这里假设是一个包含图片URL的数组
      items: [1, 2, 3, 4, 5, 6, 7, 8],
      swiperOptions: {
        // 设置为竖向轮播
        direction: 'vertical',
        // 开启循环模式，实现无极效果
        loop: true,
        // 设置自动轮播的间隔时间（单位：毫秒），这里设置为3000毫秒，即3秒
        autoplay: {
          delay: 10
        },
        // 其他可选设置，比如设置滑动速度等
        speed: 2000,
        slidesPerView: 3,
      }
    };
  },
  mounted () {
    console.log(this.list)
  }
};
